import React from 'react';

// Content of a `prominent` Like/Follow pill: the visible face plus a hidden
// copy carrying the LONGER label in the same grid cell, so the pill is always
// as wide as its saved state. Like↔Liked / Follow↔Following never resizes it —
// the header actions cluster is right-anchored, and a resize shoved the
// share/link icons on every click. Styles: .pill-stack in DJPal.scss
// (prominent-pill mixin).
export default function PillFace({ icon, label, longest }) {
    return (
        <span className="pill-stack">
            <span className="pill-face">{icon}<span>{label}</span></span>
            <span className="pill-face pill-sizer" aria-hidden="true">{icon}<span>{longest}</span></span>
        </span>
    );
}
